export default "__VITE_ASSET__BeUm4xAS__"